import {useParams} from 'react-router-dom';

import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {UserGroupDocumentTitle} from 'src/app/user-groups/userGroupHelpers';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import UserGroupForm from 'src/app/user-groups/UserGroupForm';

export const ViewUserGroupPage = () => {
  useSetDocumentTitle(UserGroupDocumentTitle);
  const {id} = useParams();

  return (
    <ContentWrapper>
      {id !== undefined && <UserGroupForm id={Number(id)} mode="view" />}
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.UserGroupView(':id', ':view'),
  element: <ViewUserGroupPage />,
  module: ModuleEnum.UserGroups,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
  allowGlobalAdminBypass: true,
});

export default ViewUserGroupPage;
